import Vue from '@vue/compat';
import channelWidgetOptions from './channel-widget.js';
import circleInfoTopOptions from './circle-info-top.js';
import momentEditorOptions from './moment-editor.js';
import momentListOptions from './moment-list.js';
import playerWrapOptions from './player-wrap.js';
import swiperCarouselOptions from './swiper-carousel.js';

function mountPage(selector, options) {
  if (!document.querySelector(selector)) return null;
  return new Vue({ el: selector, ...options });
}

/** @type {import('@vue/compat').CompatVue | null} */
window.qkMomentList = mountPage('.circle-content-wrap', momentListOptions);
window.qkMomentEditor = mountPage('.circle-editor', momentEditorOptions);
window.qkCircleInfoTop = mountPage('.circle-info-top', circleInfoTopOptions);
window.circleSwiperCarousel = mountPage('.swiper-carousel', swiperCarouselOptions);
window.circlewidget = mountPage('.circle-channel-menu-widget', channelWidgetOptions);
window.circleplayerWrap = mountPage('.single-circle .qk-player-wrap', playerWrapOptions);

export {
  channelWidgetOptions,
  circleInfoTopOptions,
  momentEditorOptions,
  momentListOptions,
  playerWrapOptions,
  swiperCarouselOptions,
};
